import React, { useState, memo } from 'react';
import { ArrowLeft, Mail, ChevronDown } from 'lucide-react';
export function SupportPage() {
  return <div className="min-h-screen w-full bg-[#FAF8F5] font-sans text-[#3A3A3A]" data-id="element-310">
      <div className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-311">
        {/* Back Link */}
        <a href="/" className="inline-flex items-center gap-2 text-[#2D4A3E] hover:text-[#2D4A3E]/80 transition-colors mb-8" data-id="element-312">
          <ArrowLeft className="w-4 h-4" data-id="element-313" />
          <span className="text-sm font-medium" data-id="element-314">Back to Home</span>
        </a>

        {/* Header */}
        <header className="mb-12" data-id="element-315">
          <h1 className="font-['DM_Sans'] text-4xl md:text-5xl font-medium text-[#3A3A3A] mb-4" data-id="element-316">
            Support
          </h1>
          <p className="text-lg text-[#3A3A3A]/70" data-id="element-317">
            We're here to help you get the most out of Cardkeeper.
          </p>
        </header>

        {/* Contact Card */}
        <section className="bg-white rounded-2xl p-8 shadow-sm border border-[#B8A99A]/20 mb-12" data-id="element-318">
          <div className="flex items-start gap-4" data-id="element-319">
            <div className="p-3 bg-[#2D4A3E]/10 rounded-full" data-id="element-320">
              <Mail className="w-6 h-6 text-[#2D4A3E]" data-id="element-321" />
            </div>
            <div data-id="element-322">
              <h2 className="font-['DM_Sans'] text-xl font-medium text-[#3A3A3A] mb-2" data-id="element-323">
                Get in Touch
              </h2>
              <p className="text-[#3A3A3A]/70 mb-4" data-id="element-324">
                Have a question, feedback, or need help? We'd love to hear from
                you.
              </p>
              <a href="mailto:support@cardkeeperapp.com" className="inline-flex items-center gap-2 bg-[#2D4A3E] text-[#FAF8F5] px-6 py-3 rounded-full font-medium hover:bg-[#2D4A3E]/90 transition-colors" data-id="element-325">
                <Mail className="w-4 h-4" data-id="element-326" />
                support@cardkeeperapp.com
              </a>
              <p className="text-sm text-[#B8A99A] mt-4" data-id="element-327">
                We typically respond within 24–48 hours.
              </p>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section data-id="element-328">
          <h2 className="font-['DM_Sans'] text-2xl font-medium text-[#3A3A3A] mb-6" data-id="element-329">
            Frequently Asked Questions
          </h2>

          <div className="space-y-3" data-id="element-330">
            <FAQItem question="When will Cardkeeper be available?" answer="Cardkeeper is launching soon on iOS. Join our waitlist to be the first to know when it's available!" data-id="element-331" />
            <FAQItem question="Is my data stored in the cloud?" answer="In the current version, all your cards and data are stored locally on your device. We don't upload your content to our servers, so you have full control over your memories." data-id="element-332" />
            <FAQItem question="Can I use Cardkeeper on Android?" answer="We're starting with iOS, but we're exploring Android support for the future. Sign up for our waitlist to stay updated on new platform releases." data-id="element-333" />
            <FAQItem question="Is Cardkeeper free?" answer="Cardkeeper will offer a free tier with core features. We may offer optional premium features through a subscription in the future." data-id="element-334" />
            <FAQItem question="How do I delete my data?" answer="Since your data is stored locally on your device, you can delete individual cards within the app or remove all data by deleting the app." data-id="element-335" />
          </div>
        </section>
      </div>
    </div>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white rounded-xl border border-[#B8A99A]/20 overflow-hidden" data-id="element-336">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-4 flex items-center justify-between text-left" data-id="element-337">
        <span className="font-['DM_Sans'] font-medium text-[#3A3A3A]" data-id="element-338">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-[#B8A99A] transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-339" />
      </button>
      {isOpen && <div className="px-6 pb-4" data-id="element-340">
          <p className="text-[#3A3A3A]/70 leading-relaxed" data-id="element-341">{answer}</p>
        </div>}
    </div>;
}